import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import { getPerson as onGetPerson } from "slices/thunks";
import Permission from "Components/Common/Permission";
import ProfileSheetEditor, {
  SheetSection,
} from "Components/Common/ProfileSheet/ProfileSheetEditor";

/**
 * The Edit link for a person section kept as lists inside the person record
 * (alias names, contact details), and the editor it opens. Shown to roles
 * with the section's permission on Person → profile-record.
 */
const PersonSheetLink = ({
  person,
  title,
  sections,
  action,
  save,
  savedMessage,
}: {
  person: any;
  title: string;
  sections: SheetSection[];
  action: string;
  save: (personId: any, payload: Record<string, any>) => Promise<any>;
  savedMessage: string;
}) => {
  const dispatch: any = useDispatch();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Permission resource="person" controller="profile-record" action={action}>
      <Link
        to="#"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsOpen(true);
        }}
        className="link-primary link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover me-3"
      >
        <i className="ri-pencil-line"></i> Edit
      </Link>
      {/* Stops portal clicks reaching a collapsible card header. */}
      <span onClick={(e) => e.stopPropagation()}>
        <ProfileSheetEditor
          isOpen={isOpen}
          toggle={() => setIsOpen(false)}
          title={title}
          owner={person}
          sections={sections}
          save={(payload) => save(person?.id, payload)}
          savedMessage={savedMessage}
          refresh={() => dispatch(onGetPerson({ id: person?.id }))}
        />
      </span>
    </Permission>
  );
};

export default PersonSheetLink;
